





// import React, { useState, useEffect, useRef } from "react";
// import {
//   Box,
//   IconButton,
//   useTheme,
//   useMediaQuery,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import RoomIcon from "@mui/icons-material/Room";
// import CustomText, { textStyles } from "../../../../components/CustomText";
// import CustomButton from "../../../../components/CustomButton";
// import { useTranslation } from "react-i18next";
// import { toast } from "react-hot-toast";
// import crossmap from "../../../../assets/crossmap.svg";
// import {
//   GoogleMap,
//   Marker,
//   Circle,
//   // useJsApiLoader,
// } from "@react-google-maps/api";
// import { useGeolocated } from "react-geolocated";
// import LocationPermissionModal from "./permissionModal";
// import { MAPS_API_KEY } from "../../../../components/mapKey";

// /* ---------- helpers ---------- */
// const circularRadius = 100;
// const GOOGLE_MAP_LIBRARIES = ["places"];
// const containerStyle = {
//   width: "100%",
//   height: "100%",
// };

// const Location = ({ onChange, onPermission, forceOpen, manualCoords }) => {
//   const [searchBarOpen, setSearchBarOpen] = useState(false);
//   const [position, setPosition] = useState(null);
//   const [address, setAddress] = useState("No address found");
//   const [showFullMap, setShowFullMap] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [suggestions, setSuggestions] = useState([]);
//   const [showPermissionModal, setShowPermissionModal] = useState(false);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const { t } = useTranslation();
//   const addressRef = useRef(null);
//   const isOnline = () => navigator.onLine;

//   // Load Google Maps API
//   // const { isLoaded, loadError } = useJsApiLoader({
//   //   googleMapsApiKey: MAPS_API_KEY,
//   //   libraries: GOOGLE_MAP_LIBRARIES,
//   // });

//   const { coords, isGeolocationAvailable, isGeolocationEnabled } =
//     useGeolocated({
//       positionOptions: { enableHighAccuracy: true },
//       userDecisionTimeout: 5000,
//     });

//   useEffect(() => {
//     console.log("[Location] props snapshot:", { forceOpen, manualCoords });
//   }, [forceOpen, manualCoords]);

//   useEffect(() => {
//     console.log("[Location] geolocation state:", {
//       isGeolocationAvailable,
//       isGeolocationEnabled,
//       coords,
//     });
//   }, [isGeolocationAvailable, isGeolocationEnabled, coords]);

//   useEffect(() => {
//     const logPermissionState = async () => {
//       try {
//         if (!navigator.permissions?.query) {
//           console.warn("[Location] Permissions API is not supported in this browser");
//           return;
//         }
//         const permission = await navigator.permissions.query({ name: "geolocation" });
//         console.log("[Location] navigator.permissions geolocation state:", permission.state);
//       } catch (err) {
//         console.warn("[Location] Failed to read navigator.permissions geolocation state:", err);
//       }
//     };
//     logPermissionState();
//   }, []);

//   const requestCurrentLocation = () => {
//     if (!navigator.geolocation) {
//       console.error("[Location] navigator.geolocation is unavailable");
//       onPermission?.(false);
//       setShowPermissionModal(true);
//       return;
//     }

//     navigator.geolocation.getCurrentPosition(
//       (pos) => {
//         const newPos = { lat: pos.coords.latitude, lng: pos.coords.longitude };
//         console.log("[Location] navigator.geolocation success:", newPos);
//         setPosition(newPos);
//         fetchAddress(newPos);
//         setShowPermissionModal(false);
//         onPermission?.(true);
//       },
//       (err) => {
//         console.error("[Location] navigator.geolocation error:", err);
//         console.error("[Location] geolocation error details:", {
//           code: err?.code,
//           message: err?.message,
//           secureContext: window.isSecureContext,
//           origin: window.location.origin,
//         });
//         if (err?.code === 2) {
//           toast.error(
//             t("locationUnavailable") ||
//               "Current location is temporarily unavailable. You can search or set it manually."
//           );
//           // Not a browser-permission issue; avoid showing misleading permission modal.
//           setShowPermissionModal(false);
//         } else if (err?.code === 1) {
//           toast.error(t("locationPermissionDenied") || "Location permission denied.");
//           setShowPermissionModal(true);
//         } else if (err?.code === 3) {
//           toast.error(t("locationTimeout") || "Location request timed out.");
//           // Timeout is often transient; allow retry without forcing permission instructions.
//           setShowPermissionModal(false);
//         }
//         if (err?.code !== 1 && err?.code !== 2 && err?.code !== 3) {
//           setShowPermissionModal(true);
//         }
//         onPermission?.(false);
//       },
//       { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
//     );
//   };

//   /* ---------- Geolocation Effect ---------- */
//   useEffect(() => {
//     if (coords) {
//       const newPos = { lat: coords.latitude, lng: coords.longitude };
//       console.log("[Location] coords received from browser:", newPos);
//       setPosition(newPos);
//       fetchAddress(newPos);
//       setShowPermissionModal(false);
//       onPermission?.(true);
//     } else if (isGeolocationAvailable === false) {
//       console.warn("[Location] geolocation not available in this browser/device");
//       setPosition(null);
//       setAddress("No address found");
//       onPermission?.(false);
//     }
//   }, [coords, isGeolocationAvailable]);

//   useEffect(() => {
//     // Permission can be granted but OS-level location can still be unavailable
//     // (e.g. temporary CoreLocation failure). Make that explicit to parent.
//     if (isGeolocationEnabled === false && !coords) {
//       console.warn("[Location] geolocation enabled=false while coords are unavailable");
//       onPermission?.(false);
//     }
//   }, [isGeolocationEnabled, coords, onPermission]);

//   useEffect(() => {
//     if (forceOpen && !coords) {
//       console.warn("[Location] forceOpen triggered; requesting current location");
//       requestCurrentLocation();
//     }
//   }, [forceOpen, coords]);

//   useEffect(() => {
//     if (isGeolocationEnabled === false && forceOpen && !coords) {
//       console.warn("[Location] geolocation disabled and forceOpen=true; trying one explicit browser location request");
//       requestCurrentLocation();
//     }
//   }, [isGeolocationEnabled, forceOpen, coords]);

//   useEffect(() => {
//     // If browser permission is granted but hook still has no coords,
//     // explicitly request once to avoid getting stuck in undefined state.
//     let isCancelled = false;

//     const tryRequestWhenGranted = async () => {
//       if (coords || forceOpen) return;
//       if (!navigator.permissions?.query) return;

//       try {
//         const permission = await navigator.permissions.query({ name: "geolocation" });
//         if (isCancelled) return;

//         if (permission.state === "granted" && isGeolocationEnabled === false && !coords) {
//           console.warn("[Location] granted permission but no coords; retrying explicit geolocation request");
//           requestCurrentLocation();
//         }
//       } catch (err) {
//         console.warn("[Location] Failed permission check in fallback effect:", err);
//       }
//     };

//     tryRequestWhenGranted();
//     return () => {
//       isCancelled = true;
//     };
//   }, [coords, forceOpen, isGeolocationEnabled]);

//   /* ---------- Handle manual address coordinates ---------- */
//   useEffect(() => {
//     if (manualCoords) {
//       console.log("[Location] manualCoords received:", manualCoords);
//       setPosition(manualCoords);
//       fetchAddress(manualCoords);
//       onChange?.({
//         latitude: manualCoords.lat,
//         longitude: manualCoords.lng,
//         country: "",
//         community: "",
//         province: "",
//         city: "",
//         postalCode: "",
//         streetAddress: "",
//         region: "",
//       });
//     }
//   }, [manualCoords]);

//   /* ---------- Fetch Address using Google Geocoding ---------- */
//   const fetchAddress = ({ lat, lng }) => {
//     // if (!isLoaded) return;
//     if (!window.google?.maps) return;

//     if (!isOnline()) {
//       toast.error(t("locationInternetError") || "No internet connection");
//       return;
//     }

//     const geocoder = new window.google.maps.Geocoder();
//     console.log("[Location] reverse geocode request:", { lat, lng });

//     geocoder.geocode({ location: { lat, lng } }, (results, status) => {
//       if (status === "OK" && results[0]) {
//         const formattedAddress = results[0].formatted_address;
//         const addressComponents = results[0].address_components;

//         let country = "";
//         let province = "";
//         let city = "";
//         let community = "";
//         let postalCode = "";
//         let streetAddress = "";
//         let region = "";

//         // Parse address components
//         addressComponents.forEach((component) => {
//           const types = component.types;

//           if (types.includes("country")) {
//             country = component.long_name;
//           }

//           if (types.includes("administrative_area_level_1")) {
//             province = component.long_name;
//           }

//           if (types.includes("locality") || types.includes("postal_town")) {
//             city = component.long_name;
//           }

//           if (types.includes("sublocality") || types.includes("neighborhood")) {
//             community = component.long_name;
//           }

//           if (types.includes("postal_code")) {
//             postalCode = component.long_name;
//           }

//           if (types.includes("route")) {
//             streetAddress = component.long_name;
//           }

//           if (types.includes("street_number")) {
//             streetAddress = component.long_name + " " + streetAddress;
//           }
//         });

//         // If city not found, try alternative
//         if (!city) {
//           addressComponents.forEach((component) => {
//             if (component.types.includes("administrative_area_level_2")) {
//               city = component.long_name;
//             }
//           });
//         }

//         // Set region based on country
//         if (country) {
//           region = "North";
//         }

//         console.log("📍 Extracted Address Components:", {
//           country,
//           province,
//           city,
//           community,
//           postalCode,
//           streetAddress,
//           region,
//         });

//         setAddress(formattedAddress);
//         if (addressRef.current) {
//           addressRef.current.value = formattedAddress;
//         }

//         onChange?.({
//           latitude: lat,
//           longitude: lng,
//           address: formattedAddress,
//           country,
//           province,
//           city,
//           community,
//           postalCode,
//           streetAddress,
//           region,
//         });
//       } else {
//         console.error("[Location] reverse geocode failed with status:", status);
//         setAddress("Address not found");

//         onChange?.({
//           latitude: lat,
//           longitude: lng,
//           address: "Address not found",
//           country: "",
//           province: "",
//           city: "",
//           community: "",
//           postalCode: "",
//           streetAddress: "",
//           region: "",
//         });
//       }
//     });
//   };

//   /* ---------- Search with Autocomplete ---------- */
//   useEffect(() => {
//     if (!searchQuery.trim() || !isLoaded) {
//       setSuggestions([]);
//       return;
//     }

//     if (!isOnline()) {
//       setSuggestions([]);
//       return;
//     }

//     const timeout = setTimeout(() => {
//       const service = new window.google.maps.places.AutocompleteService();

//       service.getPlacePredictions(
//         { input: searchQuery },
//         (predictions, status) => {
//           if (status === window.google.maps.places.PlacesServiceStatus.OK) {
//             console.log("[Location] autocomplete predictions:", predictions?.length || 0);
//             setSuggestions(predictions);
//           } else {
//             console.warn("[Location] autocomplete status:", status);
//             setSuggestions([]);
//           }
//         }
//       );
//     }, 400);

//     return () => clearTimeout(timeout);
//   }, [searchQuery, isLoaded]);

//   /* ---------- Handle Search Select ---------- */
//   const handleSearchSelect = (sug) => {
//     if (!isLoaded) return;

//     if (!isOnline()) {
//       toast.error(t("locationInternetError") || "No internet connection");
//       return;
//     }

//     const geocoder = new window.google.maps.Geocoder();
//     console.log("[Location] selected suggestion:", sug);

//     geocoder.geocode({ placeId: sug.place_id }, (results, status) => {
//       if (status === "OK" && results[0]) {
//         const location = results[0].geometry.location;

//         const newPos = {
//           lat: location.lat(),
//           lng: location.lng(),
//         };

//         console.log("🔍 Search Selected Location:", newPos);

//         setPosition(newPos);
//         fetchAddress(newPos);
//         setSearchQuery(results[0].formatted_address);
//         setSuggestions([]);
//       }
//       if (status !== "OK") {
//         console.error("[Location] place geocode failed with status:", status);
//       }
//     });
//   };

//   const handleAllowFromModal = () => {
//     if (!isOnline()) {
//       toast.error(t("locationInternetError") || "No internet connection. Please check your connection.");
//       return;
//     }

//     setShowPermissionModal(false);
//     console.log("[Location] user clicked allow in modal");
//     requestCurrentLocation();
//   };

//   /* ---------- Monitor internet connectivity ---------- */
//   useEffect(() => {
//     const handleOnline = () => {
//       toast.success(t("internetRestored") || "Internet connection restored");
//       // Retry fetching address if coordinates exist
//       if (position?.lat && position?.lng) {
//         fetchAddress(position);
//       }
//     };

//     const handleOffline = () => {
//       toast.error(t("internetConnectionLost") || "Internet connection lost");
//     };

//     window.addEventListener("online", handleOnline);
//     window.addEventListener("offline", handleOffline);

//     return () => {
//       window.removeEventListener("online", handleOnline);
//       window.removeEventListener("offline", handleOffline);
//     };
//   }, [position]);

//   if (loadError) return <Box>Error loading maps</Box>;
//   if (!isLoaded) return <Box>Loading maps...</Box>;

//   return (
//     <Box>
//       {/* Header with actions */}
//       <Box
//         sx={{
//           display: "flex",
//           flexWrap: "wrap",
//           justifyContent: "space-between",
//           alignItems: "center",
//           my: 2,
//         }}
//       >
//         <CustomText
//           customStyle={{
//             ...textStyles.body4,
//             color: theme.palette.text.primary,
//           }}
//         >
//           {t("pickFromLive")} <span style={{ color: "red" }}>*</span>
//         </CustomText>
//         <Box sx={{ display: "flex", gap: 1 }}>
//           <IconButton
//             onClick={() => setSearchBarOpen((prev) => !prev)}
//             sx={{
//               backgroundColor: "#1976d2",
//               color: "#fff",
//               borderRadius: 1,
//               width: 40,
//               height: 31,
//               "&:hover": { backgroundColor: "#1976d2" },
//             }}
//           >
//             <SearchIcon fontSize="small" />
//           </IconButton>
//           <IconButton
//             onClick={() => {
//               if (!isOnline()) {
//                 toast.error(t("locationInternetError") || "No internet connection");
//                 return;
//               }
//               if (coords) {
//                 const newPos = { lat: coords.latitude, lng: coords.longitude };
//                 setPosition(newPos);
//                 fetchAddress(newPos);
//               } else {
//                 requestCurrentLocation();
//               }
//             }}
//             sx={{
//               backgroundColor: "#1976d2",
//               color: "#fff",
//               borderRadius: 1,
//               width: 40,
//               height: 31,
//               "&:hover": { backgroundColor: "#1976d2" },
//             }}
//           >
//             <RoomIcon fontSize="small" />
//           </IconButton>
//           <CustomButton
//             label={t("fullMap")}
//             size="small"
//             sx={{
//               height: 31,
//               px: 2,
//               backgroundColor: "#1976d2",
//               color: "#fff",
//               fontSize: 12,
//               "&:hover": { backgroundColor: "#115293" },
//             }}
//             onClick={() => setShowFullMap(true)}
//           />
//         </Box>
//       </Box>

//       {/* Search input with suggestions */}
//       {searchBarOpen && (
//         <Box sx={{ mb: 2, position: "relative" }}>
//           <input
//             type="text"
//             placeholder={t("searchLocation")}
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             onKeyDown={(e) => {
//               if (e.key === "Enter") {
//                 e.preventDefault();
//               }
//             }}
//             style={{
//               width: "100%",
//               padding: "10px 14px",
//               fontSize: "15px",
//               border: "1px solid #ccc",
//               borderRadius: "8px",
//               boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
//               fontFamily: "Poppins, sans-serif",
//             }}
//           />

//           {suggestions.length > 0 && (
//             <Box
//               sx={{
//                 position: "absolute",
//                 zIndex: 1000,
//                 background: "#fff",
//                 width: "100%",
//                 border: "1px solid #ccc",
//                 borderRadius: 2,
//                 maxHeight: 300,
//                 overflowY: "auto",
//               }}
//             >
//               {suggestions.map((sug, idx) => (
//                 <Box
//                   key={idx}
//                   sx={{
//                     p: 1,
//                     cursor: "pointer",
//                     "&:hover": { backgroundColor: "#f0f0f0" },
//                   }}
//                   onClick={() => handleSearchSelect(sug)}
//                 >
//                   {sug.description}
//                 </Box>
//               ))}
//             </Box>
//           )}
//         </Box>
//       )}

//       {/* Map preview */}
//       <Box sx={{ height: 300, borderRadius: 2, overflow: "hidden" }}>
//         <GoogleMap
//           mapContainerStyle={containerStyle}
//           center={position || { lat: 37.0902, lng: -95.7129 }}
//           zoom={15}
//         >
//           {position && (
//             <>
//               <Marker
//                 position={position}
//                 draggable
//                 onDragEnd={(e) => {
//                   const newPos = {
//                     lat: e.latLng.lat(),
//                     lng: e.latLng.lng(),
//                   };
//                   setPosition(newPos);
//                   fetchAddress(newPos);
//                 }}
//               />

//               <Circle
//                 center={position}
//                 radius={circularRadius}
//                 options={{
//                   fillColor: "#3f51b5",
//                   fillOpacity: 0.2,
//                   strokeColor: "#3f51b5",
//                 }}
//               />
//             </>
//           )}
//         </GoogleMap>
//       </Box>

//       {/* Address display */}
//       <textarea
//         ref={addressRef}
//         readOnly
//         value={address}
//         rows={2}
//         style={{
//           width: "100%",
//           padding: "12px",
//           fontSize: "16px",
//           border: "1px solid #ccc",
//           borderRadius: "8px",
//           marginTop: "10px",
//           backgroundColor: "#f4f4f4",
//           fontFamily: "Poppins, sans-serif",
//           resize: "none",
//           overflowWrap: "break-word",
//           whiteSpace: "pre-wrap",
//         }}
//       />

//       {/* Full screen map */}
//       {showFullMap && (
//         <Box
//           sx={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             backgroundColor: "#fff",
//             zIndex: 1300,
//           }}
//         >
//           <IconButton
//             onClick={() => setShowFullMap(false)}
//             sx={{ position: "absolute", top: 16, right: 16, zIndex: 1400 }}
//           >
//             <img src={crossmap} alt="close" style={{ width: 50, height: 50 }} />
//           </IconButton>
//           <GoogleMap
//             mapContainerStyle={{ width: "100%", height: "100%" }}
//             center={position || { lat: 37.0902, lng: -95.7129 }}
//             zoom={15}
//           >
//             {position && (
//               <>
//                 <Marker
//                   position={position}
//                   draggable
//                   onDragEnd={(e) => {
//                     const newPos = {
//                       lat: e.latLng.lat(),
//                       lng: e.latLng.lng(),
//                     };
//                     setPosition(newPos);
//                     fetchAddress(newPos);
//                   }}
//                 />
//                 <Circle
//                   center={position}
//                   radius={circularRadius}
//                   options={{
//                     fillColor: "#3f51b5",
//                     fillOpacity: 0.2,
//                     strokeColor: "#3f51b5",
//                   }}
//                 />
//               </>
//             )}
//           </GoogleMap>
//         </Box>
//       )}

//       <LocationPermissionModal
//         open={showPermissionModal}
//         onAllow={handleAllowFromModal}
//         onCancel={() => setShowPermissionModal(false)}
//       />
//     </Box>
//   );
// };

// export default Location;



import React, { useState, useEffect, useRef } from "react";
import { Box, IconButton, useTheme, CircularProgress } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import RoomIcon from "@mui/icons-material/Room";
import CustomText, { textStyles } from "../../../../components/CustomText";
import CustomButton from "../../../../components/CustomButton";
import { useTranslation } from "react-i18next";
import { toast } from "react-hot-toast";
import crossmap from "../../../../assets/crossmap.svg";
import { GoogleMap, Marker, Circle } from "@react-google-maps/api";
import LocationPermissionModal from "./permissionModal";
import useGeolocationPermission from "../../../../Utlis/useGeolocationPermission";

const circularRadius = 100;

const containerStyle = {
  width: "100%",
  height: "100%",
};

const defaultCenter = { lat: 37.0902, lng: -95.7129 };

const LocatingPill = ({ label, zIndex = 10 }) => (
  <Box
    sx={{
      position: "absolute",
      top: 12,
      left: "50%",
      transform: "translateX(-50%)",
      zIndex,
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      gap: 1,
      px: 1.5,
      py: 0.75,
      backgroundColor: "#fff",
      borderRadius: 5,
      boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
      fontSize: 13,
      fontFamily: "Poppins, sans-serif",
    }}
  >
    <CircularProgress size={16} />
    {label}
  </Box>
);

const Location = ({ onChange, onPermission, forceOpen, manualCoords }) => {
  const [searchBarOpen, setSearchBarOpen] = useState(false);
  const [position, setPosition] = useState(null);
  const [address, setAddress] = useState("No address found");
  const [showFullMap, setShowFullMap] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [hasTriedInitialLocation, setHasTriedInitialLocation] = useState(false);
  const [locating, setLocating] = useState(false);
  const [mapsReady, setMapsReady] = useState(
    Boolean(window.google?.maps?.Geocoder)
  );

  const theme = useTheme();
  const { t } = useTranslation();
  const addressRef = useRef(null);
  const locationRequestRef = useRef(0);

  const isOnline = () => navigator.onLine;

  const debugLocation = (label, data = {}) => {
    console.log(`🧭 [Location Debug] ${label}`, {
      ...data,
      online: navigator.onLine,
      secureContext: window.isSecureContext,
      origin: window.location.origin,
      hasGoogle: Boolean(window.google),
      hasMaps: Boolean(window.google?.maps),
      hasPlaces: Boolean(window.google?.maps?.places),
      hasAutocompleteService: Boolean(
        window.google?.maps?.places?.AutocompleteService
      ),
      hasImportLibrary: Boolean(window.google?.maps?.importLibrary),
      hasGeocoder: Boolean(window.google?.maps?.Geocoder),
      geolocationAvailable: Boolean(navigator.geolocation),
    });
  };

  const fetchAddress = ({ lat, lng }) => {
    debugLocation("fetchAddress called", { lat, lng });

    if (!window.google?.maps?.Geocoder) {
      setLocating(false);
      toast.error("Google Geocoder is not ready yet");
      return;
    }

    if (!isOnline()) {
      setLocating(false);
      toast.error(t("locationInternetError") || "No internet connection");
      setAddress("No internet connection");
      return;
    }

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      setLocating(false);
      debugLocation("reverse geocode response", {
        status,
        resultsCount: results?.length || 0,
      });

      if (status === "OK" && results[0]) {
        const formattedAddress = results[0].formatted_address;
        const addressComponents = results[0].address_components;

        let country = "";
        let province = "";
        let city = "";
        let community = "";
        let postalCode = "";
        let streetAddress = "";
        let region = "";

        addressComponents.forEach((component) => {
          const types = component.types;

          if (types.includes("country")) country = component.long_name;

          if (types.includes("administrative_area_level_1")) {
            province = component.long_name;
          }

          if (types.includes("locality") || types.includes("postal_town")) {
            city = component.long_name;
          }

          if (types.includes("sublocality") || types.includes("neighborhood")) {
            community = component.long_name;
          }

          if (types.includes("postal_code")) {
            postalCode = component.long_name;
          }

          if (types.includes("route")) {
            streetAddress = component.long_name;
          }

          if (types.includes("street_number")) {
            streetAddress = `${component.long_name} ${streetAddress}`;
          }
        });

        if (!city) {
          addressComponents.forEach((component) => {
            if (component.types.includes("administrative_area_level_2")) {
              city = component.long_name;
            }
          });
        }

        if (country) region = "North";

        setAddress(formattedAddress);

        if (addressRef.current) {
          addressRef.current.value = formattedAddress;
        }

        onChange?.({
          latitude: lat,
          longitude: lng,
          address: formattedAddress,
          country,
          province,
          city,
          community,
          postalCode,
          streetAddress,
          region,
        });
      } else {
        setAddress("Address not found");

        onChange?.({
          latitude: lat,
          longitude: lng,
          address: "Address not found",
          country: "",
          province: "",
          city: "",
          community: "",
          postalCode: "",
          streetAddress: "",
          region: "",
        });
      }
    });
  };

  const updatePosition = (newPos) => {
    setPosition(newPos);
    fetchAddress(newPos);
  };

  const getCurrentLocation = () => {
    debugLocation("current location requested");

    if (!navigator.geolocation) {
      toast.error(t("geolocationNotSupported") || "Geolocation not supported");
      onPermission?.(false);
      return;
    }

    if (!isOnline()) {
      toast.error(t("locationInternetError") || "No internet connection");
      onPermission?.(false);
      return;
    }

    const requestId = ++locationRequestRef.current;
    const isStale = () => requestId !== locationRequestRef.current;

    setLocating(true);

    const onSuccess = (pos) => {
      if (isStale()) return;

      debugLocation("geolocation success", {
        latitude: pos.coords.latitude,
        longitude: pos.coords.longitude,
        accuracy: pos.coords.accuracy,
      });

      setShowPermissionModal(false);
      onPermission?.(true);
      updatePosition({
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
      });
    };

    const onFinalError = (error) => {
      if (isStale()) return;

      debugLocation("geolocation error", {
        code: error?.code,
        message: error?.message,
      });

      setLocating(false);
      onPermission?.(false);

      if (error?.code === error.PERMISSION_DENIED) {
        setShowPermissionModal(true);
        return;
      }

      setAddress(t("unableToFetchLocation"));
      toast.error(t("unableToFetchLocationToast"));
      setSearchBarOpen(true);
    };

    // Attempt 1: fast network/Wi-Fi fix, cached position up to 1 min old
    navigator.geolocation.getCurrentPosition(
      onSuccess,
      (error) => {
        if (isStale()) return;

        if (error.code === error.PERMISSION_DENIED) {
          onFinalError(error);
          return;
        }

        // Attempt 2: GPS, can be slow (especially on iOS)
        navigator.geolocation.getCurrentPosition(onSuccess, onFinalError, {
          enableHighAccuracy: true,
          timeout: 30000,
          maximumAge: 0,
        });
      },
      { enableHighAccuracy: false, timeout: 15000, maximumAge: 60000 }
    );
  };

  // The Maps script is loaded by a parent; wait for it so the first fix can be geocoded
  useEffect(() => {
    if (mapsReady) return undefined;

    const id = setInterval(() => {
      if (window.google?.maps?.Geocoder) {
        setMapsReady(true);
        clearInterval(id);
      }
    }, 200);

    return () => clearInterval(id);
  }, [mapsReady]);

  useEffect(() => {
    if (mapsReady && !hasTriedInitialLocation) {
      setHasTriedInitialLocation(true);
      getCurrentLocation();
    }
  }, [mapsReady, hasTriedInitialLocation]);

  useEffect(() => {
    if (forceOpen && mapsReady) {
      getCurrentLocation();
    }
  }, [forceOpen]);

  useEffect(() => {
    if (manualCoords) {
      debugLocation("manualCoords received", manualCoords);

      setPosition(manualCoords);
      fetchAddress(manualCoords);

      onChange?.({
        latitude: manualCoords.lat,
        longitude: manualCoords.lng,
        country: "",
        community: "",
        province: "",
        city: "",
        postalCode: "",
        streetAddress: "",
        region: "",
      });
    }
  }, [manualCoords]);

  useEffect(() => {
    debugLocation("search effect triggered", { searchQuery });

    if (!searchQuery.trim()) {
      setSuggestions([]);
      return;
    }

    if (!isOnline()) {
      setSuggestions([]);
      return;
    }

    const timeout = setTimeout(async () => {
      try {
        if (!window.google?.maps?.importLibrary) {
          debugLocation("importLibrary not available");
          setSuggestions([]);
          return;
        }

        const { AutocompleteService, PlacesServiceStatus } =
          await window.google.maps.importLibrary("places");

        if (!AutocompleteService) {
          debugLocation("AutocompleteService not available");
          setSuggestions([]);
          return;
        }

        const service = new AutocompleteService();

        service.getPlacePredictions(
          {
            input: searchQuery,
            componentRestrictions: { country: ["pk", "us", "es"] },
          },
          (predictions, status) => {
            debugLocation("autocomplete response", {
              status,
              predictionsCount: predictions?.length || 0,
              predictions,
            });

            if (status === PlacesServiceStatus.OK && predictions) {
              setSuggestions(predictions);
            } else {
              setSuggestions([]);
            }
          }
        );
      } catch (error) {
        console.error("❌ AutocompleteService failed:", error);
        setSuggestions([]);
      }
    }, 400);

    return () => clearTimeout(timeout);
  }, [searchQuery]);

  const handleSearchSelect = (sug) => {
    debugLocation("suggestion selected", sug);

    if (!window.google?.maps?.Geocoder) {
      toast.error("Google Geocoder is not ready yet");
      return;
    }

    if (!isOnline()) {
      toast.error(t("locationInternetError") || "No internet connection");
      return;
    }

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ placeId: sug.place_id }, (results, status) => {
      debugLocation("place geocode response", {
        status,
        resultsCount: results?.length || 0,
      });

      if (status === "OK" && results[0]) {
        const location = results[0].geometry.location;

        const newPos = {
          lat: location.lat(),
          lng: location.lng(),
        };

        setPosition(newPos);
        fetchAddress(newPos);
        setSearchQuery(results[0].formatted_address);
        setSuggestions([]);
        onPermission?.(true);
      } else {
        toast.error("Unable to select this location");
      }
    });
  };

  // Reflect the browser's location setting changing while the page is open
  useGeolocationPermission({
    retryOnFocus: showPermissionModal,
    onGranted: () => {
      if (!mapsReady || locating) return;
      if (showPermissionModal || !position) getCurrentLocation();
    },
    onDenied: () => {
      onPermission?.(false);
      setShowPermissionModal(true);
    },
  });

  useEffect(() => {
    const handleOnline = () => {
      toast.success(t("internetRestored") || "Internet connection restored");

      getCurrentLocation();
    };

    const handleOffline = () => {
      toast.error(
        t("internetConnectionLost") ||
          "Internet connection lost. Please check your network."
      );
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [position]);

  if (!window.google?.maps) {
    return <Box>Loading maps...</Box>;
  }

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
          my: 2,
        }}
      >
        <CustomText
          customStyle={{
            ...textStyles.body4,
            color: theme.palette.text.primary,
          }}
        >
          {t("pickFromLive")} <span style={{ color: "red" }}>*</span>
        </CustomText>

        <Box sx={{ display: "flex", gap: 1 }}>
          <IconButton
            onClick={() => setSearchBarOpen((prev) => !prev)}
            sx={{
              backgroundColor: "#1976d2",
              color: "#fff",
              borderRadius: 1,
              width: 40,
              height: 31,
              "&:hover": { backgroundColor: "#1976d2" },
            }}
          >
            <SearchIcon fontSize="small" />
          </IconButton>

          <IconButton
            onClick={getCurrentLocation}
            sx={{
              backgroundColor: "#1976d2",
              color: "#fff",
              borderRadius: 1,
              width: 40,
              height: 31,
              "&:hover": { backgroundColor: "#1976d2" },
            }}
          >
            <RoomIcon fontSize="small" />
          </IconButton>

          <CustomButton
            label={t("fullMap")}
            size="small"
            sx={{
              height: 31,
              px: 2,
              backgroundColor: "#1976d2",
              color: "#fff",
              fontSize: 12,
              "&:hover": { backgroundColor: "#115293" },
            }}
            onClick={() => setShowFullMap(true)}
          />
        </Box>
      </Box>

      {searchBarOpen && (
        <Box sx={{ mb: 2, position: "relative" }}>
          <input
            type="text"
            placeholder={t("searchLocation")}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") e.preventDefault();
            }}
            style={{
              width: "100%",
              padding: "10px 14px",
              fontSize: "15px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
              fontFamily: "Poppins, sans-serif",
            }}
          />

          {suggestions.length > 0 && (
            <Box
              sx={{
                position: "absolute",
                zIndex: 1000,
                background: "#fff",
                width: "100%",
                border: "1px solid #ccc",
                borderRadius: 2,
                maxHeight: 300,
                overflowY: "auto",
              }}
            >
              {suggestions.map((sug) => (
                <Box
                  key={sug.place_id}
                  sx={{
                    p: 1,
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#f0f0f0" },
                  }}
                  onClick={() => handleSearchSelect(sug)}
                >
                  {sug.description}
                </Box>
              ))}
            </Box>
          )}
        </Box>
      )}

      <Box
        sx={{
          position: "relative",
          height: 300,
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        {locating && <LocatingPill label={t("fetchingLocation")} />}
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={position || defaultCenter}
          zoom={position ? 15 : 4}
        >
          {position && (
            <>
              <Marker
                position={position}
                draggable
                onDragEnd={(e) => {
                  const newPos = {
                    lat: e.latLng.lat(),
                    lng: e.latLng.lng(),
                  };

                  setPosition(newPos);
                  fetchAddress(newPos);
                }}
              />

              <Circle
                center={position}
                radius={circularRadius}
                options={{
                  fillColor: "#3f51b5",
                  fillOpacity: 0.2,
                  strokeColor: "#3f51b5",
                }}
              />
            </>
          )}
        </GoogleMap>
      </Box>

      <textarea
        ref={addressRef}
        readOnly
        value={address}
        rows={2}
        style={{
          width: "100%",
          padding: "12px",
          fontSize: "16px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          marginTop: "10px",
          backgroundColor: "#f4f4f4",
          fontFamily: "Poppins, sans-serif",
          resize: "none",
          overflowWrap: "break-word",
          whiteSpace: "pre-wrap",
        }}
      />

      {showFullMap && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "#fff",
            zIndex: 1300,
          }}
        >
          <IconButton
            onClick={() => setShowFullMap(false)}
            sx={{ position: "absolute", top: 16, right: 16, zIndex: 1400 }}
          >
            <img src={crossmap} alt="close" style={{ width: 50, height: 50 }} />
          </IconButton>

          {locating && (
            <LocatingPill label={t("fetchingLocation")} zIndex={1400} />
          )}

          <GoogleMap
            mapContainerStyle={{ width: "100%", height: "100%" }}
            center={position || defaultCenter}
            zoom={position ? 15 : 4}
          >
            {position && (
              <>
                <Marker
                  position={position}
                  draggable
                  onDragEnd={(e) => {
                    const newPos = {
                      lat: e.latLng.lat(),
                      lng: e.latLng.lng(),
                    };

                    setPosition(newPos);
                    fetchAddress(newPos);
                  }}
                />

                <Circle
                  center={position}
                  radius={circularRadius}
                  options={{
                    fillColor: "#3f51b5",
                    fillOpacity: 0.2,
                    strokeColor: "#3f51b5",
                  }}
                />
              </>
            )}
          </GoogleMap>
        </Box>
      )}

      <LocationPermissionModal
        open={showPermissionModal}
        onAllow={() => {
          setShowPermissionModal(false);
          getCurrentLocation();
        }}
        onCancel={() => {
          setShowPermissionModal(false);
          onPermission?.(false);
        }}
      />
    </Box>
  );
};

export default Location;
  







       









